
import { environment } from '../environments/environment';

export const authConfig = {
  loginUrl: environment.apiUrl + '/auth/login',
  signupUrl: environment.apiUrl + '/auth/register',
  unlinkUrl: environment.apiUrl + '/auth/logout',
  refreshUrl: environment.apiUrl + '/auth/refresh',
}
